<mat-list-item class="nav-list-item">{{ label }}</mat-list-item>

<div class="nav-items">
	<ng-content></ng-content>
</div>
